/**
 * DevExtreme (esm/ui/list_light.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import ListEdit from "../__internal/ui/list/m_list.edit.search";
import registerComponent from "../core/component_registrator";
registerComponent("dxList", ListEdit);
export default ListEdit;
